import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faLongArrowAltLeft,
    faLongArrowAltRight,
} from '@fortawesome/free-solid-svg-icons'
import { Button, Box, Flex, Text } from 'rebass/styled-components'
import { Link } from 'gatsby'
import styled from 'styled-components'
import renderHTML from 'react-render-html'
import { stripHtmlTags } from '../../helpers/Functions'
import SwiperRender from '../swiper/SwiperRender'

const TestimonialContainer = styled(Flex)`
    background-image: url("data:image/svg+xml,%3Csvg width='442' height='397' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='.059'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2 61l220.988 351.276L223 493H2V61' fill='%234D4D4D'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.63 81.086C18.59 52.894 32.12 26.305 59.676 0l13.074 17.216 87.29 13.026 24.391-1.098s4.808 20.07 21.569 25.04c.217.065-31.205 12.181-31.205 12.181l8.012 31.5-20.239-13.86s-80.982 31.329-90.244-5.039c-.1-.412-7.166 4.197-7.166 4.197 1.863 1.465-5.474 46.295 89.206 30.926l23.474 4.927.036 288.984C90.82 262.104 6.869 164.57 15.631 81.086' fill='%238A8B8A'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M80 37l28 1.735S90.957 47.129 80 37M181.498 41A5.503 5.503 0 01187 46.5c0 3.036-2.464 5.5-5.502 5.5A5.503 5.503 0 01176 46.5c0-3.036 2.466-5.5 5.498-5.5' fill='%23FFFFFE'/%3E%3Cpath d='M114 235v112M100 213v112M86 192v112M129 255v112M145 276v112M161 300v112' stroke='%23FFFFFE' stroke-width='2.308' stroke-linecap='round'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M442 61L221.012 412.483 221 493h221V61' fill='%238A8B8A'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M382.323 0l-13.072 17.216-87.288 13.026-24.391-1.098s-4.814 20.07-21.571 25.04c-.217.065 31.205 12.181 31.205 12.181l-8.012 31.5 20.237-13.86s80.987 31.329 90.247-5.039c.098-.412 7.166 4.197 7.166 4.197-2.263 2.416 5.473 46.295-89.206 30.926l-23.478 4.927L264.126 408C380.578 212.84 491.477 104.209 382.323 0' fill='%234D4D4D'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M261.502 41A5.503 5.503 0 00256 46.5c0 3.036 2.464 5.5 5.502 5.5A5.502 5.502 0 00267 46.5c0-3.036-2.464-5.5-5.498-5.5' fill='%23FFFFFE'/%3E%3Cpath d='M328 235v112M343 213v112M358 192v112M313 255v112M297 276v112M281 300v112' stroke='%23FFFFFE' stroke-width='2.308' stroke-linecap='round' stroke-linejoin='bevel'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M364 37l-28 1.735s17.046 8.394 28-1.735' fill='%23FFFFFE'/%3E%3C/g%3E%3C/svg%3E");
    background-position: 0 100%;
    background-repeat: no-repeat;
    margin: 0 auto;
    padding: ${(props) => props.theme.space.xxxl}
        ${(props) => props.theme.space.md} ${(props) => props.theme.space.xl};
    position: relative;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        margin: ${(props) => props.theme.space.xl} auto;
        padding: ${(props) => props.theme.space.xl}
            ${(props) => props.theme.space[4]} 0;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
        background-position: 50% 100%;
        background-size: 100%;
        padding: ${(props) => props.theme.space.xl} 0 0;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xxs}) {
        margin: ${(props) => props.theme.space.lg} auto;
        padding-top: ${(props) => props.theme.space.lg};
    }

    button {
        position: absolute;
        top: ${(props) => props.theme.space.md};
        right: ${(props) => props.theme.space.md};
    }
`

const SwiperContainer = styled(Box)`
    max-width: 688px;
    overflow: hidden;
    position: relative;
    padding-bottom: 55px;
    .swiper-button-prev,
    .swiper-button-next {
        color: ${(props) => props.theme.colors.aquaDark};
        height: 100%;
        inset: 0;
        margin-top: 0;
        position: relative;
    }
`

const BorderContainer = styled(Box)`
    padding-left: ${(props) => props.theme.space.sm};
    padding-right: 0;
    margin-top: 62px;
    border-color: ${(props) => props.theme.colors.black};
    border-style: solid;
    border-width: 0 0 0 1px;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        max-width: none;
        padding-right: ${(props) => props.theme.space.md};
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
        border-width: 0;
        padding-left: ${(props) => props.theme.space.sm};
        padding-right: ${(props) => props.theme.space.sm};
    }

    .swiper {
        overflow: visible;
    }
`

const QuotationMark = styled(Box)`
    color: ${(props) => props.theme.colors.aquaDark};
    display: block;
    font-family: ${(props) => props.theme.fonts.heading};
    font-size: 100px;
    font-weight: ${(props) => props.theme.fontWeights.semibold};
    left: -2px;
    letter-spacing: 18px;
    line-height: 100px;
    position: absolute;
    top: 0;
`

const Name = styled(Text)`
    font-family: ${(props) => props.theme.fonts.heading};
    font-size: ${(props) => props.theme.fontSizes.xxl};
    font-weight: ${(props) => props.theme.fontWeights.semibold};
    letter-spacing: 2px;
    line-height: 30px;
    margin-top: ${(props) => props.theme.space.md};
    padding-bottom: 0;
`

const Title = styled(Text)`
    font-style: italic;
    line-height: 18px;
    padding-top: ${(props) => props.theme.space.xxs};

    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
        font-style: normal;
    }
`
const NavigationButton = styled(Box)`
    &:after {
        content: '' !important;
    }
`

const TestimonialBanner = ({ testimonials }) => {
    const slides = []

    Object.entries(testimonials).map(([key, testimonial]) => {
        const sanitisedContent = stripHtmlTags(testimonial.content)
        slides.push(
            <Box key={`${testimonial.author}-${key}`}>
                <Text variant='quote'>
                    {renderHTML(sanitisedContent || '')}
                </Text>
                <Name>{renderHTML(testimonial.author || '')}</Name>
                <Title>{renderHTML(testimonial.authorTitle || '')}</Title>
            </Box>
        )
    })
    const navigationMarkup = (
        <Flex
            mt='lg'
            sx={{
                position: 'absolute',
                bottom: '-50px',
                left: '0',
            }}
        >
            <NavigationButton
                className='swiper-button-prev'
                pr='xxs'
                fontSize='xxl'
                color='aquaDark'
                sx={{ cursor: 'pointer' }}
            >
                <FontAwesomeIcon icon={faLongArrowAltLeft} />
            </NavigationButton>
            <Box
                bg='aquaDark'
                width='2px'
                height='21px'
                mx='4px'
            ></Box>
            <NavigationButton
                className='swiper-button-next'
                pl='xxs'
                fontSize='xxl'
                color='aquaDark'
                sx={{ cursor: 'pointer' }}
            >
                <FontAwesomeIcon icon={faLongArrowAltRight} />
            </NavigationButton>
        </Flex>
    )

    return (
        <TestimonialContainer
            bg='greyLight'
            justifyContent='center'
        >
            <Link to='/about/testimonials/'>
                <Button variant='primary_greyLight'>All Testimonials</Button>
            </Link>

            <SwiperContainer>
                <BorderContainer>
                    <QuotationMark
                        sx={{ paddingLeft: ['20px', '20px', '20px', '0px'] }}
                    >
                        &#8220;&#8221;
                    </QuotationMark>
                    {testimonials && testimonials.length ? (
                        <SwiperRender
                            options={{
                                allowTouchMove: true,
                                autoHeight: true,
                                followFinger: true,
                                grabCursor: true,
                                longSwipes: true,
                                slidesPerView: 1,
                                spaceBetween: 20,
                                initialSlide: Math.floor(
                                    Math.random() * testimonials.length
                                ),
                                loop: true,
                                navigation: {
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                },
                                slides,
                                navigationMarkup,
                            }}
                        />
                    ) : null}
                </BorderContainer>
            </SwiperContainer>
        </TestimonialContainer>
    )
}

export default TestimonialBanner
